<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="1000px"
    @close="close"
  >
    <div class="print-detail">
      <el-tabs v-model="activeName" type="card" @tab-click="tabChange">
        <el-tab-pane label="待打印" name="print">
          <keep-alive>
            <tabContent v-if="activeName === 'print'" tab="print"></tabContent>
          </keep-alive>
        </el-tab-pane>
        <el-tab-pane label="已打印" name="printed">
          <keep-alive>
            <tabContent v-if="activeName === 'printed'" tab="printed"></tabContent>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import TabContent from './tabContent.vue';

export default {
  components: { TabContent },

  data() {
    return {
      dialogVisible: false,
      title: '[阳光分销商]待出货商品标签打印信息',
      activeName: 'print',
      opts: {},
    };
  },
  watch: {},
  mounted() {},
  methods: {
    openDialog(opts) {
      this.opts = opts;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    tabChange() {},
  },
};
</script>

<style lang="scss" scoped>
.print-detail {
}
</style>
